// eslint-disable-next-line import/no-extraneous-dependencies
import { GenericAPIException } from '@reward-platform/shared-api/exceptions/GenericAPIException'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Iata } from '@reward-platform/platform-config'
import axios from 'axios'
import { addSeconds } from 'date-fns'
import { getPartnerConfig } from './partner-config'
import { AccessTokenInfo } from './types'

type AccessToken = {
  accessToken: string
  expiresAt: Date
}

const accessTokens = new Map<Iata, AccessTokenInfo>()

export function getPartnerAccessToken(partner: Iata): AccessTokenInfo | undefined {
  return accessTokens.get(partner)
}

export function setPartnerAccessToken(partner: Iata, token: AccessTokenInfo) {
  accessTokens.set(partner, token)
}

function formatIssuerUrl(issuer: string): string {
  return new URL(`https://${issuer}/oauth/token`).toString()
}

export async function requestAccessToken(partner: Iata): Promise<AccessToken> {
  const { clientId, clientSecret, issuerUrl, audience } = getPartnerConfig(partner)

  type Response = { data: { access_token: string; expires_in: number } }
  const response = await axios.post<unknown, Response>(
    formatIssuerUrl(issuerUrl),
    {
      client_id: clientId,
      client_secret: clientSecret,
      audience,
      grant_type: 'client_credentials',
    },
    {
      errorHandler: GenericAPIException,
    }
  )

  return {
    accessToken: response.data?.access_token,
    expiresAt: addSeconds(new Date(), response.data?.expires_in),
  }
}
